import { render, staticRenderFns } from "./InvestigationDoctorReferralReport.vue?vue&type=template&id=15cb75c7&scoped=true"
import script from "./InvestigationDoctorReferralReport.vue?vue&type=script&lang=js"
export * from "./InvestigationDoctorReferralReport.vue?vue&type=script&lang=js"
import style0 from "./InvestigationDoctorReferralReport.vue?vue&type=style&index=0&id=15cb75c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb75c7",
  null
  
)

export default component.exports